import { useEffect, useRef, useState } from "react";

export function useCopyLinkToClipboard() {
  const [wasCopied, setWasCopied] = useState(false);
  const timeoutRef = useRef<NodeJS.Timeout>();

  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  const onCopy = async (url: string) => {
    setWasCopied(true);
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    timeoutRef.current = setTimeout(() => setWasCopied(false), 3000);
    await navigator.clipboard.writeText(url);
  };

  return { wasCopied, onCopy };
}
